import { Dispatch } from "redux";
import axiosInstance from "../Axios-Config/Axios-Config";
import { SETADDRESSDATA } from "../redux/features/delivery";
import Konsole from "../utils/konsole/Konsole";

export async function GetAllOrderApi() {
  try {
    const {
      data: {
        success,
        order_list: { data },
      },
    } = await axiosInstance.get("recent/order");
    if (success) {
      return { order_list: data };
    } else {
      return { order_list: [] };
    }
  } catch (error: any) {
    Konsole.log('error', error)
    return { order_list: [] };
  }
}


export async function GetAllAddress(dispatch: Dispatch) {
  try {
    const response = await axiosInstance.get("get/user/address");
    const addressList = response?.data?.user_address_list?.filter((i: any) => (i?.zip_code !== null || i.city !=null));
    // console.log('addressList', addressList);
    dispatch(SETADDRESSDATA(addressList));

    return addressList;
  } catch (error: any) {
    dispatch(SETADDRESSDATA([]));
    return [];
  }
}